import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue"
  import Chart from "chart.js/auto"

  interface Props {
    labels: string[]
    colors: string[]
    data: number[]
    image: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'circleProgress',
  props: {
    labels: null,
    colors: null,
    data: null,
    image: null
  },
  setup(__props: any) {

const props = __props as {
    labels: string[]
    colors: string[]
    data: number[]
    image: string
  }

  const element = ref<HTMLCanvasElement>()
  
  onMounted(() => {
    new Chart(element.value as HTMLCanvasElement, {
      type: "doughnut",
      data: {
        datasets: [
          {
            data: props.data,
            backgroundColor: props.colors,
            hoverBackgroundColor: props.colors,
            borderWidth: [0, 0],
          },
        ],
        labels: props.labels,
      },
      options: {
        cutout: "80%",
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        hover: { mode: "y" },
      },
      plugins: [
        {
          id: "beforeWorksona",
          afterDraw: (chart) => {
            const width = chart.width,
              height = chart.height,
              ctx = chart.ctx
            ctx.save()
            ctx.beginPath()
            const image = new Image()
            image.src = props.image
            image.onload = () => {
              image.width = width - 40
              image.height = height - 40
              // genrate circle
              ctx.beginPath()
              ctx.arc(width / 2, height / 2, width / 2 - 20, 0, Math.PI * 2, false)
              ctx.strokeStyle = "transparent"
              ctx.stroke()
              ctx.clip()
              // clip image to circle
              ctx.drawImage(image, width / 2 - image.width / 2, height / 2 - image.height / 2, image.height, image.height)
              ctx.restore()
            }
          },
        },
      ],
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", {
    ref_key: "element",
    ref: element
  }, null, 512))
}
}

})